import { render, staticRenderFns } from "./ConsultAdvisorsPage.vue?vue&type=template&id=658f15fb"
import script from "./ConsultAdvisorsPage.vue?vue&type=script&lang=ts"
export * from "./ConsultAdvisorsPage.vue?vue&type=script&lang=ts"
import style0 from "./ConsultAdvisorsPage.vue?vue&type=style&index=0&id=658f15fb&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports